import moment from "moment";
import { convert } from "./currencyConvertion";
import dayDifferenceHelper from "./dayDifferenceHelper";
import { dateFormat } from "../config";
import { computeBooking } from "./bookingOptionsBilling";

// Prices the selected options for `days` (per-day options multiply, flat options count once).
// Lines may carry `price` (listing options) or `unitPrice` (snapshots); other fields are kept.
const priceOptionLines = (options, days) => (options || []).map((option) => {
    const unitPrice = Number(option.price !== undefined ? option.price : option.unitPrice);
    const quantity = option.billingMode === 'per_day' ? Number(days) : 1;
    return {
        ...option,
        unitPrice,
        quantity,
        amount: Math.round((unitPrice * quantity + Number.EPSILON) * 100) / 100
    };
});

const billDetailsHelpers = ({
    serviceFees, monthlyDiscount, weeklyDiscount, startDate, delivery, options,
    endDate, startTime, endTime, basePrice, specialPricing, base, rates,
    discountForMonth, discountForWeek, currency, securityDeposit, promoValue, deductionType
}) => {

    let dayDifference, stayedNights = [], isSpecialPriceAssigned = false, bookingSpecialPricing = [];
    let priceForDays = 0, discount = 0, discountType = null, total = 0, isAverage = 0, isDayTotal = 0;
    let currentDay, totalWithoutServiceFee = 0, serviceFee = 0, hostServiceFee = 0;
    let promoDiscount = 0, discountPromoError = false;

    if (startDate && endDate) {
        dayDifference = dayDifferenceHelper({ startTime, endTime, startDate, endDate });

        if (dayDifference > 0) {
            /* Find stayed nights. */
            for (let i = 0; i < dayDifference; i++) {
                let currentDate = moment(startDate).add(i, 'day');
                stayedNights.push(currentDate);
            };

            if (stayedNights && stayedNights.length > 0) {
                stayedNights.map((item) => {
                    let isSpecialPricing;
                    if (item) {
                        let pricingRow, currentPrice;
                        currentDay = (moment(item).format('dddd').toLowerCase());
                        isSpecialPricing = specialPricing.find(o => moment(item).format(dateFormat?.shortDateFormat) == moment(o.blockedDates).format(dateFormat?.shortDateFormat));

                        if (isSpecialPricing && isSpecialPricing.isSpecialPrice) {
                            isSpecialPriceAssigned = true;
                            currentPrice = Number(isSpecialPricing.isSpecialPrice);
                        } else {
                            currentPrice = Number(basePrice);
                        }
                        // Price object
                        pricingRow = {
                            blockedDates: item,
                            isSpecialPrice: currentPrice,
                        };
                        bookingSpecialPricing.push(pricingRow);
                    }
                });
            };
        }

        if (isSpecialPriceAssigned) {
            bookingSpecialPricing.map((item) => {
                priceForDays = priceForDays + Number(item.isSpecialPrice);
            });
        } else {
            bookingSpecialPricing.map((item) => {
                priceForDays = priceForDays + Number(item.isSpecialPrice);
            });
        };
    };

    isAverage = Number(priceForDays) / Number(dayDifference);
    isDayTotal = isAverage.toFixed(2) * dayDifference;
    priceForDays = isDayTotal;

    let isWeeklyDiscountApplied = false;
    let isMonthlyDiscountApplied = false;

    if (dayDifference >= 7) {
        if (monthlyDiscount > 0 && dayDifference >= 28) {
            discount = (Number(priceForDays) * Number(monthlyDiscount)) / 100;
            discountType = monthlyDiscount + "% " + discountForMonth;
            isMonthlyDiscountApplied = true;
        } else if (weeklyDiscount > 0 && dayDifference >= 7) {
            discount = (Number(priceForDays) * Number(weeklyDiscount)) / 100;
            discountType = weeklyDiscount + "% " + discountForWeek;
            isWeeklyDiscountApplied = true;
        }
    };

    if (Number(promoValue) > 0 && (isWeeklyDiscountApplied || isMonthlyDiscountApplied)) {
        discountPromoError = true;
    }


    if (promoValue > 0 && !discountPromoError) {
        promoDiscount = Number(priceForDays) * Number(promoValue) / 100

    }

    // `options` are the selected option lines ({ price, billingMode, ... }). `delivery` is the legacy
    // flat delivery amount: it is only used (as a flat option) when `options` is not provided.
    let selectedOptions = options;
    if (!Array.isArray(selectedOptions)) {
        selectedOptions = Number(delivery) > 0
            ? [{ code: 'delivery', billingMode: 'flat', price: Number(delivery) }]
            : [];
    }
    const optionLines = priceOptionLines(selectedOptions, dayDifference);

    const fees = {};
    if (serviceFees) {
        fees.guest = {
            type: serviceFees?.guest?.type,
            value: serviceFees?.guest?.value,
            fixedAmount: serviceFees?.guest?.type === 'percentage' ? 0 : convert(base, rates, serviceFees?.guest?.value, serviceFees?.guest?.currency, currency)
        };
        fees.host = {
            type: serviceFees?.host?.type,
            value: serviceFees?.host?.value,
            fixedAmount: serviceFees?.host?.type === 'percentage' ? 0 : convert(base, rates, serviceFees?.host?.value, serviceFees?.host?.currency, currency)
        };
    }

    // Shared engine: fee base = rental after discounts + options.
    const booking = computeBooking({
        priceForDays: isDayTotal,
        discount,
        promoDiscount,
        promoDeductionType: deductionType == "admin" ? 'admin' : null,
        options: optionLines,
        fees,
        securityDeposit
    });
    totalWithoutServiceFee = booking.feeBase;
    serviceFee = booking.guestServiceFee;
    hostServiceFee = booking.hostServiceFee;
    total = booking.totalPaid;

    return {
        isAverage, isDayTotal, discount, discountType, priceForDays,
        serviceFee, hostServiceFee, total, dayDifference, isSpecialPriceAssigned, bookingSpecialPricing,
        promoDiscount, discountPromoError,
        options: booking.options, optionsTotal: booking.optionsTotal,
        feeBase: booking.feeBase, totalWithoutServiceFee
    }
};

export default billDetailsHelpers;
